  export function transformHtmlPrice(value: string): number {
  // exemple of
    const match = value.match(/[\d,.]+/);
    return match ? parseFloat(match[0].replace(',', '.')) : 0;
  }

  export function transformHtmlPrice2(value: string): number {
    // Exemple de value: __HTML_0__74,00 €__HTML_1__

    // Regex pour capturer les nombres avec virgules ou points comme séparateurs décimaux
    // et gérer les séparateurs de milliers
    const match = value.match(/[\d\s]*[\d]+[,.]\d+|[\d\s]*[\d]+/);

    if (!match) {
      return 0;
    }

    let numberStr = match[0];

    // Nettoyer les espaces
    numberStr = numberStr.replace(/\s/g, '');

    // Si le nombre contient une virgule, la remplacer par un point pour parseFloat
    // Gérer le cas où il y a à la fois des points (séparateurs de milliers) et une virgule (décimale)
    if (numberStr.includes(',')) {
      // Si il y a un point avant la virgule, c'est un séparateur de milliers
      if (numberStr.indexOf('.') < numberStr.indexOf(',')) {
        numberStr = numberStr.replace(/\./g, '').replace(',', '.');
      } else {
        // Sinon, remplacer juste la virgule par un point
        numberStr = numberStr.replace(',', '.');
      }
    }

    const result = parseFloat(numberStr);
    return isNaN(result) ? 0 : result;
  }
